import { AbstractControl, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

const isEmptyInputValue = (value: any): boolean => {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

export class ValidadorSenha {
    static igual(control): ValidatorFn {
        return (c: AbstractControl): ValidationErrors | null => {
            if (isEmptyInputValue(c.value))
                return null;

            if (c.parent.get(control).value != c.value)
                return { igual: true }

            return null;
        };
    }

    static diferente(control): ValidatorFn {
        return (c: AbstractControl): ValidationErrors | null => {
            if (isEmptyInputValue(c.value))
                return null;

            if (c.parent.get(control).value == c.value)
                return { diferente: true }

            return null;
        };
    }
}

export class CpfCnpjValidator implements Validator {

    static cpfLength = 11;
    static cnpjLength = 14;

    /**
     * Calcula o dígito verificador do CPF ou CNPJ.
     */
    static buildDigit(arr: number[]): number {

        const isCpf = arr.length < CpfCnpjValidator.cpfLength;
        const digit = arr
            .map((val, idx) => val * ((!isCpf ? idx % 8 : idx) + 2))
            .reduce((total, current) => total + current) % CpfCnpjValidator.cpfLength;

        if (digit < 2 && isCpf) {
            return 0;
        }

        return CpfCnpjValidator.cpfLength - digit;
    }

    /**
     * Valida um CPF ou CNPJ de acordo com seu dígito verificador.
     */
    static validate(c: AbstractControl): ValidationErrors | null {

        const cpfCnpj = c && c.value ? c.value.replace(/\D/g, '') : null;

        if (!cpfCnpj || cpfCnpj.trim() === '') {
            return null;
        }

        // Verifica o tamanho da string.
        if ([CpfCnpjValidator.cpfLength, CpfCnpjValidator.cnpjLength].indexOf(cpfCnpj.length) < 0) {
            return { length: true };
        }

        // Verifica se todos os dígitos são iguais.
        if (/^([0-9])\1*$/.test(cpfCnpj)) {
            return { equalDigits: true };
        }

        // A seguir é realizado o cálculo verificador.
        const cpfCnpjArr: number[] = cpfCnpj.split('').reverse().slice(2);

        cpfCnpjArr.unshift(CpfCnpjValidator.buildDigit(cpfCnpjArr));
        cpfCnpjArr.unshift(CpfCnpjValidator.buildDigit(cpfCnpjArr));

        if (cpfCnpj !== cpfCnpjArr.reverse().join('')) {
            // Dígito verificador não é válido, resultando em falha.
            return { digit: true };
        }

        return null;
    }

    /**
     * Implementa a interface de um validator.
     */
    validate(c: AbstractControl): ValidationErrors | null {
        return CpfCnpjValidator.validate(c);
    }
}


export class DataValidator {

    static min(value: Date): ValidatorFn | null {
        return (c: AbstractControl): ValidationErrors | null => {
            // parse control value to Date
            const date = new Date(c.value);
            
            if(!c.value)
                return null;

            // check if control value is superior to date given in parameter
            if (value.getTime() < date.getTime()) {
                return null;
            } else {
                return { 'min': { value: c.value, expected: value } };

            }
        }
    }

    static max(value: Date): ValidatorFn | null {
        return (c: AbstractControl): ValidationErrors | null => {
            // parse control value to Date
            const date = new Date(c.value);
            // check if control value is superior to date given in parameter
            if(!c.value)
                return null;
            
            if (value.getTime() > date.getTime()) {
                return null;
            } else {
                return { 'max': { value: c.value, expected: value } };

            }
        }
    }
}